import React, { Component } from 'react'
import './ServiceNameHeader.less'

export class ServiceNameHeader extends Component {
    render() {
        return (
            <div className="service-name-header">
                <h2 className="main-heading">
                    {this.props.heading}
                </h2>
                {this.props.subheading &&
                    <h3 className="sub-heading">
                        “{this.props.subheading}”
                </h3>
                }
            </div>
        )
    }
}

export default ServiceNameHeader
